import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loader from 'components/Loader';
import NotFound from 'pages/error/NotFound';
import PublicRoutes from 'routes/PublicRoutes';
import PrivateRoutes from 'routes/PrivateRoutes';
import { auth, onAuthStateChanged } from 'config/firebase';
import axios from 'config/axios';
import AppWrapper from 'components/AppWrapper';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { signIn, signOut } from 'store/user';
import { setOrganization, organizationNotFound } from 'store/organization';

function App() {
    const { user, isAuthenticating } = useAppSelector(state => state.user);
    const { initializing, organization } = useAppSelector(state => state.organization);
    const dispatch = useAppDispatch();

    const urlSlug = window.location.host.split('.')[0];

    const getOrganizationData = async () => {
        try {
            const { data } = await axios.get(`tutors/organization/${urlSlug}/`);

            dispatch(setOrganization(data?.organization));
        }
        catch (error) {
            console.log(error);

            dispatch(organizationNotFound());
        }
    }

    const fetchData = async () => {
        try {
            const { data } = await axios.get('students/');

            dispatch(signIn(data?.user));
        }
        catch (error) {
            console.log(error);
            if (error.code !== 'ERR_NETWORK') {
                dispatch(signIn(null));
            }
        }
    }

    useEffect(() => {
        getOrganizationData();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchData();
            }
            else {
                dispatch(signOut());
            }
        });
    }, []);

    useEffect(() => {
        if (organization.navbarHeight) {
            document.documentElement.style.setProperty('--navbarHeight', `${organization.navbarHeight}px`);
        }
        if (organization.themeColor) {
            document.documentElement.style.setProperty('--themeColor', organization.themeColor);
        }
        if (organization.backgroundColor) {
            document.documentElement.style.setProperty('--backgroundColor', organization.backgroundColor);
        }
    }, [organization]);

    // useEffect(() => {
    //     console.log(store.getState());
    // });

    if (initializing || isAuthenticating) {
        return (
            <Routes>
                <Route path='/health' element={<h1></h1>} />
                <Route path='*' element={<Loader />} />
            </Routes>
        );
    }
    else if (!organization.alias) {
        return (
            <Routes>
                <Route path='/health' element={<h1></h1>} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        );
    }

    return (
        <AppWrapper>
            <Helmet>
                {/* <title>
                    Study with {organization?.name}
                </title> */}
                {organization.favicon && <link rel='icon' href={organization.favicon} />}
                <meta name='robots' content='noindex'></meta>
            </Helmet>
            {user
              ? <PrivateRoutes />
              : <PublicRoutes />
            }
        </AppWrapper>
    );
}

export default App;